import EnvVariables from "./interface/env"

// esbuild doesn't like injected env variables much... this gets round it :shrug:
const env = ENVIRONMENT_NAME
const graphql = GRAPH_QL
const apigq = API_GW
const islocal = IS_LOCAL
const bundleref = BUNDLE_REF
const public_url = PUBLIC_URL

export default {
  ENVIRONMENT_NAME: env,
  GRAPH_QL: graphql,
  API_GW: apigq,
  IS_LOCAL: islocal,
  BUNDLE_REF: bundleref,
  PUBLIC_URL: public_url
} as EnvVariables
